(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ProcessedSchedulerItem', ProcessedSchedulerItem);

    ProcessedSchedulerItem.$inject = ['$resource', 'DataUtils'];

    function ProcessedSchedulerItem ($resource, DataUtils) {
        var resourceUrl =  'api/processed-scheduler-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'findAllByFilter': {url: 'api/processed-scheduler-items/filter', method: 'GET', isArray: true},
            'savePendingPatientOrder': {url: 'api/processed-scheduler-items/pending-patient-order', method: 'POST'},
            'download': {
                url: 'api/processed-scheduler-items/download/:id',
                method: 'GET',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadFile(data, headers);
                }
            }
        });
    }
})();
